import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';

import {templates} from '../../styles/themes/index';
import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import HomePageContent from './HomePageContent';
import {
  checkOpeningTime, getNextOpeningsDetails, getOpenButtonText, getOpeningsDetails, getOrderNowButtonText,
  isRestaurantOpen
} from '../../helpers/date.helper';
import {GOOGLE_MAP_API_KEY} from '../../constants/constant';

export const HomePage = props => {
  const {restaurant, template, serverOffline} = props;
  const {openingTimes, thirdPartyServices, modes, coordinates} = restaurant;

  const isOpen = isRestaurantOpen(openingTimes, modes, serverOffline);
  const isOrderAvailable = (isOpen || modes.futureOrder) && modes.onlineOrdering;
  const openButtonText = getOpenButtonText(openingTimes, modes, serverOffline);
  const orderNowButtonText = getOrderNowButtonText(openingTimes, modes, serverOffline);

  const googleMapUrl = (coordinates && coordinates.latitude && coordinates.longitude) ?
    `https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.latitude},${coordinates.longitude}&zoom=16&size=640x260&maptype=roadmap&key=${GOOGLE_MAP_API_KEY}` :
    null;

  const openForDelivery = checkOpeningTime(openingTimes.delivery) && modes.delivery;
  const openForCollection = checkOpeningTime(openingTimes.collection) && modes.collection;
  const isOpenForCollectionOrDelivery = openForCollection || openForDelivery;
  const openingTimesContent = isOpen ? getOpeningsDetails(openingTimes.openings) : getNextOpeningsDetails(openingTimes.openings);
  const isOpensInSevenDays = openingTimesContent && moment().add(7, 'days').isAfter(moment(openingTimesContent.from), 'day');

  return (
    <HomePageContent
      restaurant={restaurant}
      preferences={templates[template.name].preferences.homePage}
      headerColor={template.headerColour}
      isOpen={!!isOpen}
      isOrderAvailable={!!isOrderAvailable}
      openButtonText={openButtonText}
      orderNowButtonText={orderNowButtonText}
      thirdPartyServices={thirdPartyServices}
      googleMapUrl={googleMapUrl}
      isOpenForCollectionOrDelivery={!!isOpenForCollectionOrDelivery}
      openingTimesContent={openingTimesContent}
      isOpensInSevenDays={!!isOpensInSevenDays}
    />
  );
};

HomePage.propTypes = {
  restaurant: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  serverOffline: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language,
    template: state.template,
    serverOffline: state.serverOffline
  };
};

export default connect(mapStateToProps)(ContextProvider(HomePage));



// WEBPACK FOOTER //
// ./containers/HomePage/HomePage.js